import {useEffect, useState} from "react";
import CarouselPagination from "./CarouselPagination";

const CarouselServices = ({props}) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [item, setItem] = useState(false);
    const [pause, setPause] = useState(true);

    useEffect(() => {
        if (props && props.length > 0) {
            setItem(props[currentPage])
        }
    }, [currentPage, props])

    useEffect(() => {
        if (pause){
            const timeout = setTimeout(() => {
                setCurrentPage((prevCurrentPage) =>
                    prevCurrentPage >= props.length - 1 ? 0 : prevCurrentPage + 1
                );
            }, 2000); // Задержка 2 секунды
            return () => clearTimeout(timeout); // Очистка таймера при каждом рендере
        }
    }, [pause, currentPage, props.length]);


    const previousPage = () => {
        setCurrentPage((prev) => (prev > 0 ? prev - 1 : props.length - 1));
    };

    const nextPage = () => {
        setCurrentPage((prev) => (prev >= props.length - 1 ? 0 : prev + 1));
    };

    const handleSetPage = (page) => {
        setCurrentPage(page)
    }

    return (
        <div className="carousel__cont mt-32">
                <div className="relative"
                     onClick={() => setPause(false)}
                     onMouseEnter={() => setPause(false)}
                     onMouseLeave={() => setPause(true)}
                     onTouchStart={()=> setPause(false)}
                >
                    <CarouselPagination
                        nextPage={nextPage}
                        previousPage={previousPage}
                        handleSetPage={handleSetPage}
                        arr={props.length}
                        currentPage={currentPage}
                        item={item}
                    />
                </div>
        </div>
    )
}

export default CarouselServices